var map = {
	"../components/not-found/not-found.module": [
		"./src/app/components/not-found/not-found.module.ts",
		"components-not-found-not-found-module"
	],
	"./components/access-denied/access-denied.module": [
		"./src/app/components/access-denied/access-denied.module.ts",
		"components-access-denied-access-denied-module"
	],
	"./components/forgotten/forgotten.module": [
		"./src/app/components/forgotten/forgotten.module.ts",
		"common",
		"components-forgotten-forgotten-module"
	],
	"./components/login/login.module": [
		"./src/app/components/login/login.module.ts",
		"common",
		"components-login-login-module"
	],
	"./components/send/send.module": [
		"./src/app/components/send/send.module.ts",
		"common",
		"components-send-send-module"
	],
	"./components/server-error/server-error.module": [
		"./src/app/components/server-error/server-error.module.ts",
		"components-server-error-server-error-module"
	],
	"./components/signup/signup.module": [
		"./src/app/components/signup/signup.module.ts",
		"common",
		"components-signup-signup-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts"
	],
	"./profile/profile.module": [
		"./src/app/layout/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./version/version.module": [
		"./src/app/layout/version/version.module.ts",
		"version-version-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;